export const formatBallsAsOvers = (balls: number): string => {
	if (!Number.isFinite(balls) || balls < 0) {
		return "0.0";
	}

	const wholeBalls = Math.floor(balls);
	const overs = Math.floor(wholeBalls / 6);
	const ballsRemainder = wholeBalls % 6;

	return `${overs}.${ballsRemainder}`;
};
